@if (shouldDisplay()) {
<div class="bg-gradient-to-r from-yellow-400 to-amber-500 transform overflow-hidden h-[40px] flex items-center justify-center relative">
<div class="animate-scroll whitespace-nowrap absolute">
<span class="inline-block px-4 text-white font-medium text-[14px]">
{{ bannerMessage()?.text }}
</span>
</div>
</div>
}
